import React, { FC } from "react";

import classNames from "classnames";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";

import logo from "@assets/rrs-logo.svg";
import { ResaleCart } from "@components/resale_submission/SummaryCart/ResaleCart";

import { ROUTES } from "../../routes";

import styles from "./DashboardHeader.module.scss";

export const DashboardHeader: FC<{ showResaleCart?: boolean }> = ({ showResaleCart = true }) => {
  return (
    <div className={classNames(styles["header"], "d-flex align-items-center")}>
      <Link className="z-3" to={ROUTES.Dashboard.path}>
        <ReactSVG className={styles["logo"]} src={logo} />
      </Link>
      {showResaleCart && <ResaleCart />}
    </div>
  );
};
